export default __webpack_public_path__ + "static/media/bgDownloadMb.9234f14a.png";